import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    central: Boolean(false),
    rowVersion: null,

    cajaDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_CAJA' (state, cajaId) {
        state.id = cajaId;
        state.nombre = '';
        state.central = Boolean(false);
        state.rowVersion = null;
    },
    'SET_CAJA' (state, caja) {
        state.nombre = caja.nombre.toUpperCase().trim();
        state.central = Boolean(caja.central);
        state.rowVersion = caja.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.cajaDatos = [];
    },
    'SET_DATOS'(state, datos) {
        state.cajaDatos = datos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, cajaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJA', cajaId);

            if (cajaId != 0) {
                apiAxios.get('cajas/' + cajaId + '/abm' ) 
                .then(res => {
                    commit('SET_CAJA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let caja = {
                nombre: state.nombre.toUpperCase().trim(),
                central: state.central,
            }

            let url = 'cajas';
            if (state.id != 0) {
                url += '/' + state.id;
                caja.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, caja)
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, cajaId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (cajaId) {
                if (cajaId != 0) {
                    apiAxios.get('cajas/' + cajaId ) 
                    .then(res => {
                        var datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'central', 'campo': 'Central', 'valor': (res.data.central) ? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));                    
                }
            } 
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}